export default [{
  name: 'queryFlight',
  method: 'post',
  desc: '获取国内航班列表',
  path: '/obt/queryFlight',
  params: {
    'arriveAirport': '',
    'departAirport': '',
    'tripType': '1',
    'empRank': '',
    'departDate': ''
  }
}, {
  name: 'GetClzbByMinZj',
  method: 'post',
  desc: '获取机票差旅标准',
  path: '/obt/GetClzbByMinZj',
  params: {
    'arriveAirport': '',
    'departAirport': '',
    'empRank': '',
    'departDate': '',
    'ccsqdId': '',
    'auditType': ''
  },
  loading: '0'
}, {
  name: 'matchClbz',
  method: 'post',
  desc: '国内机票是否违背',
  path: '/obt/matchClbz',
  params: {
    'cacheId': '',
    'minZj': '0',
    'routeId': '',
    'ccsqdId': '',
    'auditType': ''
  },
  loading: '0'
}, {
  name: 'validateTimeOut',
  method: 'post',
  desc: '机票是否超时',
  path: '/obt/validateTimeOut',
  params: {
    'cacheId': '',
    'cabinKey': '',
  }
}, {
  name: 'getAddConPrice',
  method: 'post',
  desc: '获取国内机票价格明细',
  path: '/obt/getAddConPrice',
  params: {
    rangeBeanList: [],
    tripType: ''
  }
}, {
  name: 'patForFlight',
  method: 'post',
  desc: '获取国内机票浮动价格',
  path: '/obt/patForFlight',
  params: {
    'cabin': '',
    'cacheId': '',
    'flightNo': '',
    'priceId': '',
    'tripType': '',
  }
}, {
  name: 'checkYlgqTkno',
  method: 'post',
  desc: '预留改签',
  path: '/obt/checkYlgqTkno',
  params: {
    psgName: []
  }
}, {
  name: 'bookOrder',
  method: 'post',
  desc: '国内机票下单',
  path: '/obt/bookOrder',
  params: {
    ccsqdId: '',
    ccsqdNo: '',
    ccsqdRemark: '',
    costCenterCode: '',
    costCenterId: '',
    costCenterName: '',
    subjectCode: '',
    empRank: '',
    linkEmail: '',
    linkMan: '',
    linkTel: '',
    orderFrom: '',
    postCode: '', //邮编
    'projectCode': '',
    'projectId': '',
    'projectName': '',
    rangeType: '',
    reciAddr: '', //收件地址
    reciPhone: '',
    reciPient: '', //收件人
    routeId: '', //行程ID
    sendMode: 1, //公司统一配送
    'supplierId': '',//供应商id
    'travelNo': '',//出差申请单号
    travelStandard: '', //标准差标等级
    tripType: '',//因公因私
    psgList: [],
    rangeList: [],
    bxcpList: [],
    minPriceRemark:'', //验价原因
    minFlightRemark:'',//列表原因
    registerHuMember:''//是否注册海航会员
  }
}, {
  name: 'queryFlightRuleNew',
  method: 'post',
  desc: '获取退改签规则及行李额',
  path: '/obt/queryFlightRuleNew',
  params: {
    airline: '',
    cabin: '',
    departDate: '',
    salePrice: ''
  }
}, {
  name: 'queryFlightStop',
  method: 'post',
  desc: '获取经停信息',
  path: '/obt/queryFlightStop',
  params: {
    date: '',
    flightNo: '',
    departAirport: '',
    arriveAirport: '',
    cacheId:'',
  }
},
// 蜗牛航班数据
//     POST /obt/plane/shopping/queryFlightMinPrice
// 航班数据查询（第一屏）
{
  name: 'queryFlightMinPrice',
  method: 'post',
  desc: '航班数据查询（第一屏）',
  path: '/obt/plane/shopping/queryFlightMinPrice',
  params: {
    'departDate': '',
    'departAirport': '',
    'arriveAirport': '',
    'tripType': '1',
    'cabinType': '',
    'showGpProduct': '',
    'showChdPrice': '0'
  }
},
// 新增接 口
{
  name: 'getCtripCacheInfo',
  method: 'post',
  desc: '航班数据查询',
  path: '/obt/plane/shopping/getCtripCacheInfo',
  params: {
    'departDate': '',
    'departAirport': '',
    'arriveAirport': '',
    'cacheId': '',
  },
  loading: '0'
},
{
  name: 'queryCtripFlightMinPrice',
  method: 'post',
  desc: 'obt第一屏提供比价接口',
  path: '/obt/plane/shopping/queryCtripFlightMinPrice',
  params: {
    'cacheId': '',
    'flightNo': '',
    'cabinType': '',

  },
},
// POST /obt/plane/shopping/queryFlightRule
// 机票查询退改签
{
  name: 'queryFlightRule',
  method: 'post',
  desc: '机票查询退改签',
  path: '/obt/plane/shopping/queryFlightRule',
  params: {
    'cacheId': '',
    'flightNo': '',
    'cabin': '',
    'priceId': ''
  }
},
// POST /obt/plane/shopping/queryMoreCabin
// 根据航班查询更多舱位信息（第二屏）
{
  name: 'queryMoreCabin',
  method: 'post',
  desc: '根据航班查询更多舱位信息（第二屏）',
  path: '/obt/plane/shopping/queryMoreCabin',
  params: {
    'cacheId': '',
    'flightNo': '',
    'tripType': '',
    'corpId': ''
  }
},
{
  name: 'validateMinPrice',
  method: 'post',
  desc: '判断是不是东美最低价',
  path: '/obt/validateMinPrice',
  params: {
    'cacheId': '',
    'priceId': '',
    'flightNo': '',
    'cabin': '',
    'checkType': ''
  }
},
{
  name: 'tkNeedOrderList',
  method: 'post',
  desc: '机票 -- 查询询价单',
  path: '/obt/tkNeedOrderList',
  params: {
    'dateEnd': '', // 询价日止
    'dateStart': '', // 询价日始
    'pageNum': 1,
    'count': 20
  }
},
{
  name: 'AgreementPolicy',
  method: 'post',
  desc: '三方协议--企业政策优惠',
  path: '/obt/plane/set/agreement/prefPolicy',
  params: {
    corpId: ''
  },
},
{
  name: 'checkXyhAge',
  method: 'post',
  desc: '三方协议--企业政策优惠',
  path: '/obt/plane/shopping/checkXyhAge',
  params: {
    datas: [
      {
        'cacheId': '',
        'priceId': '',
        'flightNo': '',
        'cardNo': '',
        'cardType': '',
        'age': ''
      }
    ]
  }
},
{
  name: 'huMemberCheckByPsg',
  method: 'post',
  desc: '海航会员注册',
  path: '/obt/huMemberCheckByPsg',
  params: {
    psgList: [],
  }
},


]
